module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAVCAYAAACQcBTNAAAAzUlEQVQ4T2Ps6uycXlpWlsXIyPifgQBg7O7o+M/w//9CeWXl5LCwsL/41EMUMzAwMDIyrvzy/XtcQ0PDL1wa4IqhCjazc3GF5uXl/cSmAV0xAyMDw/4vP374NDQ0fEPXgKEYquDYXwYGr4qKio/IGnApBqk5/fvfP++qqqrXMA34FIN8fYX1zx+Xgurql+BAgIUGniC7+4+R0aG8vPwJMYpB5jxi/v/fmVjFIA0niVVMtMlEupmE0CA6nImLQVLSBnGpjvj0TGxOISUPAgCnG5b5UlzYSQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right_icon.png
// module id = 110
// module chunks = 28